export default __webpack_public_path__ + "static/IMG_1261-8f89a7995ee732d9d46fd3693f910b66.jpg";